import { render, staticRenderFns } from "./SlotItem.vue?vue&type=template&id=f0371a5a&scoped=true"
import script from "./SlotItem.vue?vue&type=script&lang=js"
export * from "./SlotItem.vue?vue&type=script&lang=js"
import style0 from "./SlotItem.vue?vue&type=style&index=0&id=f0371a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0371a5a",
  null
  
)

export default component.exports